import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {b64toBlob, create_UUID, filterSubDivisions, getCityName, showAxiosError} from "../../util/Helpers";
import * as headerContent from "../../constants/exportcontent";
import Alert from "react-s-alert";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import moment from "moment";
import FileSaver from "file-saver";
import IncomeForm from "./IncomeForm";


class AccrualList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedAccrual: null,
            branches: null,
            cities: [],
            accruals: [],
            totalIdList: [],
            years: [],
            loading: false,
            searching: false,
            searchQuery: undefined,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            addIncomeModal: false,
            downloadExcelModal: false,
            mode: 'create',
            subdivisions: [],
            accrualDueDate:null,
        };

        this.listAccruals = this.listAccruals.bind(this);
        this.cancelPaymentCreation = this.cancelPaymentCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.listBranches = this.listBranches.bind(this);
        this.handleExportReceipt = this.handleExportReceipt.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
    }

    componentDidMount() {
        this.listCities();
        this.listBranchSubdivisions();
        this.listBranches();
        this.listPaymentTypes();
        this.listTransactionChannels();
    }

    listCities = () => {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city/listByBranch/",
            //url: API_BASE_URL+"/city/" ,
            method: "get",
        };
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listBranchSubdivisions = () => {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city-subdivision/filterByBranch",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let subdivisions = response.data;
                self.setState({
                    subdivisions,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listPaymentTypes() {
        let self = this;
        let params = {
            //url: API_BASE_URL+"/transaction-type/expenses" ,
            url: API_BASE_URL + "/transaction-type/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionTypes = response.data;
                console.log("transactionTypes", transactionTypes);
                self.setState({
                    transactionTypes,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listTransactionChannels() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/transaction-channel/list",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let transactionChannels = response.data;
                console.log("transactionChannels", transactionChannels);
                self.setState({
                    transactionChannels,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listBranches() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/oda/oda-list/",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let branches = response.data;
                self.setState({
                    branches,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    listAccruals(accessor, direction, page, size) {
        let self = this;
        let sortStr = !!accessor ? ('&sort=' + accessor + ',' + direction) : '&sort=relatedYear,id,desc';
        let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
        let params = {
            url: API_BASE_URL + '/accrual/fetchAccurals?page=' + page + '&size=' + size + sortStr + searchQuery,
            method: "get",
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual, searching: true});
        request(params)
            .then(function (response) {
                let accruals = (response.data && response.data.page) ? response.data.page.content : [];
                let totalIdList = response.data ? response.data.selectedIdList : [];
                let totalChanged = false;
                if (response.data.page.totalElements !== self.state.total) {
                    totalChanged = true;
                }
                self.setState({
                    page: !totalChanged ? page : 0,
                    size: size,
                    total: response.data.page.totalElements,
                    accruals,
                    totalIdList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }

    handleExportReceipt(item) {
        let params = {
            url: API_BASE_URL + "/receipt/create-form/" + item.financialTransaction.receipt.id,
            method: 'get'
        };
        request(params).then(function (response) {
            const data = response.data.substring(response.data.indexOf(',') + 1);
            let blob = b64toBlob(data, 'application/pdf;charset=utf-8');
            FileSaver.saveAs(blob, item.financialTransaction.receipt.receiptNo + "_" + item.financialTransaction.branchId + "_Makbuz.pdf");
        }).catch(function (error) {
            showAxiosError(error);
        });

    }

    cancelPaymentCreation() {
        this.setState({
            addIncomeModal: false,
            selectedAccrual: null,
            downloadExcelModal: false
        })
    }

    handleEdit(item) {
        let self = this;
        console.log("item", item);
        let accrualDueDate=item.accrualDueDate;
        self.setState({
            mode: 'edit',
            selectedAccrual: item,
            addIncomeModal: true,
            accrualDueDate:accrualDueDate
        })
    }

    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true
        }, () => this.listAccruals(this.state.accessor, this.state.direction, page, this.state.size))
    }

    arrangeDataSet() {
        let dataSet = {};
        dataSet.headers = headerContent.accrualContent;
        dataSet.sheetName = 'Tahakkuk Kayıtları Listesi';
        dataSet.uuid = create_UUID();
        dataSet.idList = this.state.totalIdList;
        return dataSet;
    }

    async handleDownloadExcel() {
        let self = this;
        let data = self.arrangeDataSet();
        let params = {
            url: API_BASE_URL + '/accrual/downloadReport',
            method: "post",
            data: data,
        };
        await request(params).then(function () {
            Alert.success(
                "İndirme işleminiz sıraya alındı, İndirme işlemi tamamlandıktan sonra 'İNDİRME TALEPLERİNİZ'" +
                " butonuna tıklayarak excel dosyasını indirebilirsiniz.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 6000
                });
            self.cancelPaymentCreation();
        }).catch(function (error) {
            showAxiosError(error);
        });
    }

    render() {

        let branchSelectdata;
        let citySelectdata;
        let subDivisonSelectedData;
        let  subDivisionList;
        const {branches} = this.props;
        const {cities} = this.props;
        const {accruals} = this.state;
        const header_ = [{value: null, label: "Tümü"}];

        const header = [
            {value: null, label: "Tümü"},
            {value: "0", label: "BİRLİK MERKEZİ"},
        ];
        const accrualStatus = [
            {value: null, label: "Tümü"},
            {value: "1", label: "TAHSİL EDİLDİ"},
            {value: "0", label: "TAHSİL EDİLMEDİ"},
        ];

        const uyelikDurumu = [
            {value: null, label: "Tümü"},
            {value: 'true', label: "AKTİF"},
            {value: 'false', label: "PASİF"},
        ];

        const accrualType = [
            {value: null, label: "Tümü"},
            {value: "RegistrationFee", label: "Oda Giriş Aidatı"},
            {value: "YearlyFee", label: "Yıllık Aidat"},
        ];

        const subDivisions = [
            {value: null, label: "Tümü"},
        ];

        subDivisionList = filterSubDivisions(this.state.subdivisions);
        branches ? branchSelectdata = header.concat(branches) : branchSelectdata = header;
        cities ? citySelectdata = header_.concat(cities) : citySelectdata = header_;
        subDivisonSelectedData = subDivisionList ?   subDivisions.concat(subDivisionList) : subDivisions;

        const columns = [

            {
                Header: "Ad",
                accessor: "member.ad",
                Cell: item => (
                    <label>{item.member.ad}</label>)
            },
            {
                Header: "Soyad",
                accessor: "member.soyad",
                Cell: item => (
                    <label>{item.member.soyad}</label>)
            },
            {
                Header: "TCKN",
                accessor: "member.tcKimlikNo",
                Cell: item => (
                    <label>{item.member.tcKimlikNo}</label>)
            },
            {
                Header: "Sicil No",
                accessor: "member.odaSicilNo",
                Cell: item => (
                    <label>{item.member.odaSicilNo}</label>)
            },
            {
                Header: "Cep Telefonu",
                accessor: "member.gsmTel",
                Cell: item => (
                    <label>{item.member.gsmTel !== null ? item.member.gsmTel : ""}</label>)
            },
            {
                Header: "Tahakkuk Tipi",
                accessor: "accrualType",
                Cell: item => (
                    <label>{(item.accrualType === "RegistrationFee") ? "O. Giriş Aidatı" : "Yıllık Aidat"}</label>)

            },
            {
                Header: "Dönem",
                accessor: "relatedYear",
            },
            {
                Header: "Tarih",
                accessor: "accrualDate",
                Cell: item => (
                    <label>{moment.utc(item.accrualDate).format("DD.MM.YYYY")}</label>)
            },
            {
                Header: "Şehir",
                accessor: "member.city.id",
                Cell: item => (
                    <label>{item.member.city.id && getCityName(this.state.cities, item.member.city.id)}</label>)
            },
            {
                Header: "Üyelik",
                accessor: "member.uyelikAktif",
                Cell: item => (
                    <label>{item.member.uyelikAktif && item.member.uyelikAktif === true ? "Aktif" : "Pasif"}</label>)
            },
            {
                Header: "Tutar",
                accessor: "amount",
                Cell: item => (<label>{item.amount && item.amount + " ₺"}</label>)
            },
            {
                Header: "Tahsilat Durumu",
                accessor: "financialTransaction",
                Cell: item => (
                    <label>{(item.financialTransactionId === null) ? "TAHSİL EDİLMEDİ" : "TAHSİL EDİLDİ"}</label>)

            },
        ];
        /*        if(this.props.currentUser.realm.toString()==="0"){
                columns.push({
                    Header: "Oda",
                    accessor: "branchId",
                    Cell: item => (
                        <label>{branchSelectdata && getLabelByValue(branchSelectdata,item.branchId).toString().substring(0,15)+".." }</label>
                    )
                });}*/

        columns.push({
            Header: "İşlemler",
            accessor: "",
            sortable: false,
            Cell: item => (
                <div>
                    <button type="button"
                            onClick={() => this.handleEdit(item)}
                            data-toggle="tooltip" data-placement="bottom" title="Tahsilat"
                            style={{background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}
                            rel="tooltip" className="Btn btn-sm btn-icon">
                        <i className="fas fa-exchange-alt"/>
                    </button>
                    {(item.financialTransaction && item.financialTransaction.receipt) &&
                        <button type="button"
                                onClick={() => this.handleExportReceipt(item)}
                                data-toggle="tooltip" data-placement="bottom" title="Makbuz İndir"
                                style={{background: 'linear-gradient( rgb(241, 241, 37), rgb(220, 214, 8))'}}
                                rel="tooltip" className="Btn btn-sm btn-icon">
                            <i className="fas fa-download"/>
                        </button>
                    }
                </div>
            )
        });

        const fields = [
            {
                accessor: "relatedYear",
                label: "Tahakkuk Dönemi",
                type: "text",
                operator: "=",
            },
            {
                label: "Tahsilat Durumu",
                accessor: "financialTransaction_id",
                type: "select",
                operator: "=",
                selectData: accrualStatus,
            },
            {
                accessor: "member.ad",
                label: "Ad",
                type: "text",
                operator: "=",
            },
            {
                accessor: "member.soyad",
                label: "Soyad",
                type: "text",
                operator: "=",
            },
            {
                accessor: "member.odaSicilNo",
                label: "Oda Sicil No",
                type: "text",
                operator: "=",
            },
            {
                accessor: "member.tcKimlikNo",
                label: "TC Kimlik No",
                type: "text",
                operator: "=",
            },
            {
                label: "Tahakkuk Tarihi(..'den Sonra)",
                accessor: "min_accrualDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: ">=",
            },
            {
                label: "Tahakkuk Tarihi(..'den Önce)",
                accessor: "max_accrualDate", //min_xxx MUST ALWAYS come before the max_xxx, if it exists.
                type: "date",
                operator: "<=",
            },
            {
                label: "Oda İlişiği",
                accessor: "member.uyelikAktif",
                type: "select",
                operator: "=",
                selectData: uyelikDurumu,
            },

        ];

        if (this.props.currentUser.realm.toString() === "0") {
            fields.push({
                label: "Oda",
                accessor: "branchId",
                type: "select",
                operator: "=",
                selectData: branchSelectdata,
            },);
        }

        fields.push({
                label: "İl",
                accessor: "member.city.id",
                type: "select",
                operator: "=",
                selectData: citySelectdata,
            },
            {
                label: "Tahakkuk Tipi",
                accessor: "accrualType",
                type: "select",
                operator: "=",
                selectData: accrualType
            },
            {
                label: "İlçe",
                accessor: "citySubDivision",
                type: "select",
                operator: "=",
                selectData: subDivisonSelectedData,
            },);

        return (
            <div className="financial-transaction-list-container">
                <div className="row baseBackground">
                    <div className="col-md-12 satirBasi">
                        <div className="card-header ">
                            <h4 className="card-title">Tahakkuk Listesi</h4>
                        </div>
                        <div className="card-body mt-1">
                            <div className=" ">
                                <div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
                                    <DetailedSearch fields={fields}
                                                    loading={this.state.searching}
                                                    onSearch={this.handleSearch}/>
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            <Table
                                loading={this.state.loading}
                                loadingText="Kayıtlar getiriliyor..."
                                content={accruals}
                                total={this.state.total}
                                page={this.state.page}
                                manual={this.state.manual}
                                size={this.state.size}
                                options={["5", "10", "20", "50", "100"]}
                                columns={columns}
                                fetchData={this.listAccruals}
                                style={{width:"100%", marginLeft:"-10px"}}
                            />
                        </div>
                        <div>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    title="Excel İndir" disabled={this.state.isLoading}
                                    style={{
                                        background: 'linear-gradient(#129a30, #116128)',
                                        height: '40px',
                                        width: '160px',
                                        float: 'right',
                                        marginRight: '30px',
                                        color: 'white',
                                        borderRadius: '0.375em',
                                    }}
                                    rel="tooltip" className="TekBtn excel "

                                    onClick={() => this.handleDownloadExcel()}>
                                EXCEL İNDİR
                            </button>
                        </div>
                    </div>
                    <Modal isOpen={this.state.addIncomeModal} size="lg" className="ust">
                        <ModalHeader toggle={this.cancelPaymentCreation}>Aidat Tahsilatı</ModalHeader>
                        <ModalBody>
                            <IncomeForm cancelProcess={this.cancelPaymentCreation}
                                        selectedAccrual={this.state.selectedAccrual}
                                        mode={this.state.mode}
                                        currentUser={this.props.currentUser}
                                        handleSearch={this.handleSearch}
                                        transactionTypes={this.state.transactionTypes}
                                        allBranches={this.props.allBranches}
                                        transactionChannels={this.state.transactionChannels}
                                        channel="accrual"
                                        accrualDueDate={this.state.accrualDueDate}
                            />
                        </ModalBody>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default AccrualList;



// WEBPACK FOOTER //
// ./src/page/financial/AccrualList.js